import React from 'react';
import { connectHits } from 'react-instantsearch-dom';

import LocationCardRL from '3-components/LocationCard/LocationCardRL';
import LocationCardRAC from '3-components/LocationCard/LocationCardRAC';

const CustomLocationHits = props => {
    const { hits, listingType, bookTourUrl, bookTourTitle } = props;

    const renderHit = hit => {
        // console.log('hit', hit);
        if (listingType === 'RL') {
            return (
                <li className="ais-Hits-item" key={hit.name}>
                    <LocationCardRL
                        hit={hit}
                        bookTourUrl={bookTourUrl}
                        bookTourTitle={bookTourTitle}
                    />
                </li>
            );
        }

        if (listingType === 'RAC') {
            return (
                <li className="ais-Hits-item" key={hit.name}>
                    <LocationCardRAC
                        hit={hit}
                        bookTourUrl={bookTourUrl}
                        bookTourTitle={bookTourTitle}
                        key={hit.name}
                    />
                </li>
            );
        }

        return null;
    };

    return (
        <div className="ais-Hits">
            <ul className="ais-Hits-list">
                {hits.map(hit => renderHit(hit))}
            </ul>
        </div>
    );
};

export default connectHits(CustomLocationHits);
